import { Component, computed, signal } from '@angular/core';

export interface Testimonial {
  quote: string;
  name: string;
  taller: string;
}

@Component({
  selector: 'app-testimonials',
  standalone: true,
  templateUrl: './testimonials.html',
  styleUrl: './testimonials.scss',
})
export class TestimonialsComponent {
  readonly testimonials: Testimonial[] = [
    {
      quote: '"No esperaba que un taller creativo me hiciera conectar tanto conmigo. Salí con una sensación de calma que hacía tiempo no tenía!"',
      name: 'María Gómez',
      taller: 'Taller de bienestar & creatividad',
    },
    {
      quote: '"Una experiencia preciosa. El espacio, la dinámica, la energía… todo estaba pensado para que te sintieras bien. Repetiré sin duda."',
      name: 'Laura Sánchez',
      taller: 'Taller crear desde la calma',
    },
    {
      quote: '"Vine sin saber muy bien qué esperar y me fui con algo difícil de explicar pero muy necesario. Os recomiendo a todo el mundo."',
      name: 'Carmen Ruiz',
      taller: 'Taller explorar con color',
    },
  ];

  readonly currentIndex = signal(0);

  readonly active = computed(() => this.testimonials[this.currentIndex()]);

  readonly hasMore = computed(
    () => this.currentIndex() < this.testimonials.length - 1,
  );

  showMore(): void {
    if (this.hasMore()) {
      this.currentIndex.update((i) => i + 1);
    }
  }
}
